export default {
  L_DEVICE_TITLE: "Quản lý thiết bị",

  OBJ_DEVICE_TABLE_COL: {
    ipAddress: "Địa chỉ IP",
    name: "Tên thiết bị",
    source: "Loại",
    email: "Người dùng",
  },

  OBJ_SOURCE: {
    wan: "Wan",
    internet: "Internet",
  },
};
